module.exports = __webpack_public_path__ + "static/media/purple-rectangle.2da45425.webp";